<template>
    <div>
        <div class="row">
            <div class="col col-12 col-md-4">
                <az-input label="Banco" 
                    type="select" 
                    service="bancos.index" 
                    optionsMode="aql" 
                    optionsData="id_banco"
                    :validate="validate"
                    v-model="value.id_banco" />
            </div>
            <template v-if="value.id_banco">
                <div class="col col-12 col-md-4">
                    <az-input 
                        label="Agência" 
                        type="mask"
                        mask="####"
                        required
                        :validate="validate"
                        v-model="value.in_agencia" />
                </div>
                <div class="col col-12 col-md-4">
                    <az-input 
                        label="Conta" 
                        type="mask"
                        mask="##########"
                        required
                        :validate="validate"
                        v-model="value.in_conta" />
                </div>

            </template>
        </div>
        <div v-if="value.id_banco" class="row">
            <div class="col col-12 col-md-4">
                    <az-input 
                        label="Dígito da Conta" 
                        type="mask"
                        mask="X"
                        :validate="validate"
                        v-model="value.ch_digito_conta" />
                </div>
                <div class="col col-12 col-md-4">
                    <az-input 
                        label="Dígito da Agência" 
                        type="mask"
                        mask="X"
                        :validate="validate"
                        v-model="value.ch_digito_agencia" />
                </div>
                <div class="col col-12 col-md-4">
                    <az-input 
                        label="Dígito da Agência/Conta" 
                        type="mask"
                        mask="X"
                        :validate="validate"
                        v-model="value.ch_digito_agencia_conta" />
                </div>
        </div>
        <div class="row" v-if="value.id_banco">
            <div class="col">
                <az-input label="Observação" v-model="value.st_observacoes" />
            </div>
        </div>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
export default {
    data () { 
        return { 

        }
    },

    components: { 
        AzInput,
    },

    props: ['value', 'validate'],
}
</script>